import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || null;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (!r.ok) {
      setError(r.error);
      toast.error(r.error);
      return;
    }
    toast.success("Vítejte zpět!");
    const target =
      from ||
      (r.user.role === "provider" ? "/dashboard/provider" :
       r.user.role === "admin" ? "/admin" :
       "/dashboard/customer");
    navigate(target);
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1 container-page py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div className="hidden lg:block">
          <div className="tiny-label mb-3">Vítejte zpět</div>
          <h1 className="font-display text-4xl xl:text-5xl font-extrabold tracking-tight text-slate-900">
            Pereme za vás, abyste mohli žít.
          </h1>
          <p className="mt-5 text-slate-600 max-w-md">
            Přihlaste se a podívejte se na své objednávky, věrnostní body a nadcházející svozy.
          </p>
        </div>

        <Card className="p-8 max-w-md w-full mx-auto">
          <h2 className="font-display text-2xl font-bold text-slate-900">Přihlášení</h2>
          <p className="text-sm text-slate-500 mt-1">Pokračujte ke svému účtu.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vy@email.cz"
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password">Heslo</Label>
              <Input
                id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
              />
            </div>
            {error && <div className="text-sm text-rose-600">{error}</div>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? "Přihlašuji…" : "Přihlásit se"}
            </Button>
          </form>
          <div className="mt-4 text-sm text-slate-600 flex items-center justify-between">
            <Link to="/zapomenute-heslo" className="text-sky-600 hover:underline" data-testid="login-forgot-link">
              Zapomenuté heslo?
            </Link>
          </div>
          <div className="mt-5 text-sm text-slate-600">
            Nemáte účet?{" "}
            <Link to="/registrace" className="text-sky-600 font-semibold hover:underline" data-testid="login-to-register">
              Zaregistrujte se
            </Link>
          </div>
        </Card>
      </main>
      <Footer />
    </div>
  );
};

export default Login;
